export const READ_WRITE = 3;